export class WaterBody {

    constructor(geoSection, data = {}) {

        this.id = data.id ?? null;
        this.uid = data.uid ?? null;
        this.name = data.name ?? null;
        this.geoSection = geoSection ?? null;
        this.elevationTop = data.elevationTop ?? null;
        this.elevationBottom = data.elevationBottom ?? null;
        this.verticalLevelTop = data.verticalLevelTop ?? null;
        this.verticalLevelBottom = data.verticalLevelBottom ?? null;
        this.thickness = data.thickness ?? null;
        this.waterBodyType = data.waterBodyType ?? null;
        this.waterUnitWeightGamaW = data.waterUnitWeightGamaW ?? null;
        this.poissonCoefficientNiWater = data.poissonCoefficientNiWater ?? null;
        this.coefficientOfSidePressureKWater = data.coefficientOfSidePressureKWater ?? null;
        this.waterSurfaceStressCalcMethod = data.waterSurfaceStressCalcMethod ?? null;
        this.waterSurfaceStress = data.waterSurfaceStress ?? null;
        this.waterSurfaceStressGiven = data.waterSurfaceStressGiven ?? null;
        this.piezometricHeadCalcMethod = data.piezometricHeadCalcMethod ?? null;
        this.piezometricHead = data.piezometricHead ?? null;
        this.piezometricHeadGiven = data.piezometricHeadGiven ?? null;
        this.hasWaterBodyAboveRelation = data.hasWaterBodyAboveRelation ?? null;
        this.additionalStressTop = data.additionalStressTop ?? null;
        this.hasWaterBodyBelowRelation = data.hasWaterBodyBelowRelation ?? null;
        this.additionalStressBottom = data.additionalStressBottom ?? null;
        this.waterBodyAbove = data.waterBodyAbove ?? null;
        this.waterBodyBelow = data.waterBodyBelow ?? null;
        this.additionalStressEffectiveTop = data.additionalStressEffectiveTop ?? null;
        this.additionalStressEffectiveBottom = data.additionalStressEffectiveBottom ?? null;
        this.waterBodyPressureIncreaseCoefKzInc = data.waterBodyPressureIncreaseCoefKzInc ?? null;
        this.waterBodyPressureUzIncrease = data.waterBodyPressureUzIncrease ?? null;
        this.waterBodyPressureUzTop = data.waterBodyPressureUzTop ?? null;
        this.waterBodyPressureUzBottom = data.waterBodyPressureUzBottom ?? null;
        this.notes = data.notes ?? null;

    }

    get elevationOfZeroDatumLevel() {
        return this.geoSection?.elevationOfZeroDatumLevel ?? null;
    }

    get waterBodyPressureRelations() {
        return (((this.hasWaterBodyAboveRelation) && (this.hasWaterBodyBelowRelation)) ? ("AboveBelow") : (((this.hasWaterBodyAboveRelation) ? ("Above") : (((this.hasWaterBodyBelowRelation) ? ("Below") : ("None"))))));
    }

    get waterBodyAbovePressureUzBottom() {
        return this.waterBodyAbove?.waterBodyPressureUzBottom ?? null;
    }

    get waterBodyBelowPressureUzTop() {
        return this.waterBodyBelow?.waterBodyPressureUzTop ?? null;
    }

}
